import React, { useState, useEffect } from 'react'
import MediaPlayer from 'app/components/MediaPlayer'
import { Avatar, Card, Row, Col, Typography, Drawer, Select, Result, Spin, Modal, Badge } from 'antd';
import Link from '@material-ui/core/Link';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import CssBaseline from '@material-ui/core/CssBaseline';
import Grid from '@material-ui/core/Grid';
import NavMenu from 'components/NavMenu';
import TextEvents from 'app/components/TextEvents';
import { useStyles, styles } from './EmployeeDashboardScreenStyles';
import EmployeeDashboardContainer from 'app/containers/EmployeeDashboardContainer';
import CarouselForm from 'app/components/CarouselForm';
import { useSelector, useDispatch } from 'react-redux';
import { clearCommunicationProgramSummary, fetchCommunicationProgramSummary, clearCommunicationProgramById, clearSpecialtySummary, fetchSpecialtySummary, clearSystemSummary, fetchSystemSummary } from 'app/actions/CommunicationActions';
import { PURGE } from 'redux-persist';
import { clearAll } from 'app/actions/CommunicationActions';
import { clearAllStates, acceptDisclaimerBegin } from 'app/actions/LoginActions'
import Auth from '../../../config/auth'
import { auth, employeeById, acceptDisclaimer, acceptDisclaimerIsLoading, disclaimerActiveIsLoading, disclaimerActive } from 'app/reducers';
import { Pie3D } from 'react-pie3d'
const { Option } = Select;


const { Title } = Typography;

const SelectItem = (name = [], value) => {
    let x = name[value]
    x = name.map(i => i[value]);
    return typeof x !== 'undefined' && x !== null ? x.map((c, i) => <Option key={i}>{c}</Option>) : (x === null ? <Option key={'cargando'}>No existen valores..</Option> : <Option disabled key={'cargando'}>Cargando valores..</Option>);

}

export default function EmployeeDashboardScreen(props) {
    const classes = useStyles();
    const userData = useSelector(auth);
    const employeeData = useSelector(employeeById);
    const dispatch = useDispatch();
    const activeKey = '1';
    const [isVisible, setVisible] = useState(false);
    const tabs = { '1': 'Gestión de comunicación' }
    const [communicationProgram, setCommunicationProgram] = useState('');
    const [IsSelected, setSelected] = useState(false);
    const defaultValue = ['GENERAL'];
    const userAcceptDisclaimer = useSelector(acceptDisclaimer);
    const isLoading = useSelector(acceptDisclaimerIsLoading);
    const isLoadingDisclaimerActive = useSelector(disclaimerActiveIsLoading);
    const disclaimerActiv = useSelector(disclaimerActive);

    const colorGraphP = '#FF7333';
    const colorGraphF = '#1B99D6';
    const [graphPending, setgraphPending] = useState(0);
    const [graphFinished, setgraphFinished] = useState(0)

    const PieConfig = {
        angle: 70,
        tooltipShowName: true,
        tooltipShowPercentage: true,
        tooltipShowValue: true,
        showTooltips: true,
        ir: 0,
        size: 1,
        moveDistance: 0,
        height: 15
    }

    useEffect(() => {
        return () => {
            dispatch(clearCommunicationProgramById());
            dispatch(clearCommunicationProgramSummary());
            dispatch(clearSpecialtySummary());
            dispatch(clearSystemSummary());
        }
    }, []);

    const handleChange = (value, i, key, testQuestion) => {
        const id = testQuestion.filter(item => {
            return item.communicationProgramName === i.props.children
        });
        dispatch(clearCommunicationProgramSummary());
        dispatch(fetchCommunicationProgramSummary({ idEmployee: (userData.User.IdCompany == null ? userData.User.UserId : userData.User.IdCompany), idCommunicationProgram: id[0].idCommunicationProgram }));
        dispatch(clearSpecialtySummary());
        dispatch(fetchSpecialtySummary({ idEmployee: (userData.User.IdCompany == null ? userData.User.UserId : userData.User.IdCompany), idCommunicationProgram: id[0].idCommunicationProgram }));
        dispatch(clearSystemSummary());
        dispatch(fetchSystemSummary({ idEmployee: (userData.User.IdCompany == null ? userData.User.UserId : userData.User.IdCompany), idCommunicationProgram: id[0].idCommunicationProgram }));
        setCommunicationProgram(id[0].idCommunicationProgram);
        setSelected(true)

    }

    const pieChartUpdate = (finished, pending) => {
        const reload = pending !== undefined && finished !== undefined;
        return reload ? <Pie3D config={PieConfig} data={[
            { value: parseFloat(finished), label: 'Finalizados', color: colorGraphF },
            { value: parseFloat(pending), label: 'Pendinetes', color: colorGraphP },
        ]} /> : null
    }

    const showPercentageGraph = (target, rest) => {
        //Target y Rest ya son porcentajes \:v/
        const percentage = (target * 100 / (target + rest)).toFixed(2);
        return percentage === "NaN" ? 'Calculando...' : `${percentage}%`;
    }

    const disclaimer = <Auth>
        {(params) => {
            return (

                <Modal
                    title="Aviso de Seguridad de la Información para proveedores"

                    visible={true}
                    onOk={() => dispatch(acceptDisclaimerBegin({ employeeId: userData.User.UserId.toString(), disclaimerId: disclaimerActiv.disclaimerId }))}
                    onCancel={() => params.logOut(() => {
                        dispatch(clearAll())
                        dispatch(clearAllStates())
                        dispatch({
                            type: PURGE,
                            key: 'root',
                            result: () => {
                                params.logOut(() => {
                                    props.history.push('/');
                                }, true);
                            }
                        });
                    })}
                    width={900}
                    okText='Estoy de acuerdo'
                    cancelText='No estoy de acuerdo'
                    closable={false}
                    maskClosable={false}
                    keyboard={false}
                    okButtonProps={{ disabled: isLoading || isLoadingDisclaimerActive }}
                    cancelButtonProps={{ disabled: isLoading || isLoadingDisclaimerActive }}
                >
                    <Spin spinning={isLoading || isLoadingDisclaimerActive} >
                        <p>
                            {disclaimerActiv.texto}
                        </p>

                        <p>Liga al Aviso de Privacidad: <a href={disclaimerActiv.urlTerminos}>{disclaimerActiv.urlTerminos}</a></p>
                    </Spin>
                </Modal>

            )
        }}
    </Auth>

    return (
        <div className={classes.root}>
            <NavMenu SelectedIndex={props.history.location.pathname} header='Gestión de comunicación' isCommunicationStatus={false} />


            <CssBaseline />
            <div className={classes.content}>
                <div className={classes.appBarSpacer} />
                <div elevation={0} style={styles.titleBox}>
                    <Breadcrumbs aria-label="Breadcrumb">
                        <Link color="inherit" disabled>
                            Gestión
                        </Link>
                        <TextEvents
                            text={tabs[activeKey]}
                            color="cotemar"
                            size='subtitle'
                            weight="bold"
                        />
                    </Breadcrumbs>
                </div>
                <Card className={classes.tabContainer}>
                    {employeeData !== undefined ?
                        <Row >
                            <Col span={8} offset={6}>
                                <Title level={3}> {employeeData.firstName + ' '
                                    + employeeData.lastName + ' - ' + employeeData.employeeId}</Title>
                                {employeeData.categoryName}

                            </Col>
                            <Col span={4} offset={4}>
                                <Avatar size={100} src={typeof employeeData === 'undefined' ? '' : employeeData.avatar} icon="user" />
                            </Col>
                        </Row> : <div className={classes.spin}><Spin /></div>}
                </Card>
                <div className="card-container" >
                    <Card className={classes.tabContainer}>
                        <EmployeeDashboardContainer communicationProgramid={communicationProgram} IsSelected={IsSelected} setSelected={setSelected} userData={userData.User}>
                            {(params) => {
                                //Para inicalizar los estados de la grafica nueva
                                { setgraphPending(params.chartArray[1][1]) }
                                { setgraphFinished(params.chartArray[2][1]) }

                                return params.CommunicationProgramById.length === 0 ? <Result
                                    status="warning"
                                    title="Sin comunicaciones asignadas."
                                /> :
                                    <Grid container >
                                        <Grid item xs={4}>
                                            <TextEvents
                                                text='Programa de comunicación'
                                                color='darker'
                                                size='label'
                                                weight='medium'
                                            />
                                            <Select
                                                showSearch
                                                optionFilterProp="children"
                                                style={{ width: '100%' }}
                                                placeholder="Selecciona programa de comunicación"
                                                defaultValue={defaultValue}
                                                onChange={(v, i) => handleChange(v, i, 'EmployeeCP', params.CommunicationProgramById)}
                                            >
                                                {SelectItem(params.CommunicationProgramById, 'communicationProgramName')}
                                            </Select>
                                        </Grid>
                                        <Grid item xs={12}>
                                            {/* GRAFICA ONLINE CON CHARTS GOOGLE (DESCOMENTAR PARA USAR) */}
                                            {/* <Chart
                                                width={'100%'}
                                                height={'500px'}
                                                chartType="PieChart"
                                                loader={<div>Loading Chart</div>}
                                                data={params.chartArray}
                                                options={{
                                                    title: `Resumen de cumplimiento: ${params.CommunicationProgramSummary.finalizedPercentage}%`,
                                                    // Just add this option
                                                    is3D: true,
                                                    slices: {
                                                        0: { color: '#FF7333' },
                                                        1: { color: '#1B99D6', offset: 0.2 }
                                                    },

                                                }}
                                                rootProps={{ 'data-testid': '2' }}
                                            /> */}
                                            {/* Nuva grafica 'offline', descomentar para usar */}
                                            <Row align='middle' justify='space-around'>
                                                <Col span={9}></Col>
                                                <Col span={6} align='middle' justify='space-around'>
                                                    {/* No muestra decimales */}
                                                    {/* <h3>{`Resumen de cumplimiento: ${params.CommunicationProgramSummary.finalizedPercentage}%`}</h3> */}
                                                    <h3> {`Resumen de cumplimiento: ${showPercentageGraph(graphFinished, graphPending)}`}</h3>
                                                </Col>
                                                <Col span={9}></Col>
                                            </Row>
                                            <Row align='middle' justify='space-around'>
                                                <Col span={7}>
                                                </Col>
                                                <Col span={6}>
                                                    {pieChartUpdate(graphFinished, graphPending)}
                                                </Col>
                                                <Col span={6}>
                                                    <Badge color={colorGraphF} text={`Finalizado (${showPercentageGraph(graphFinished, graphPending)})`} /> <br />
                                                    <Badge color={colorGraphP} text={`Pendiente (${showPercentageGraph(graphPending, graphFinished)})`} />
                                                </Col>
                                                <Col span={5}>
                                                </Col>
                                            </Row>

                                        </Grid>
                                        <Grid container >
                                            <Grid item xs={12}>
                                                <CarouselForm classes={classes} specialityData={params.specialitySummary} systemData={params.systemSummary} />
                                            </Grid>
                                        </Grid>
                                    </Grid>

                            }}
                        </EmployeeDashboardContainer>
                        {/* <MediaPlayer ></MediaPlayer> */}
                    </Card>
                </div>

                <Drawer
                    title="Basic Drawer"
                    placement={'right'}
                    closable={false}
                    onClose={() => setVisible(false)}
                    visible={isVisible}
                ></Drawer>
                {
                    userData.User.IdCompany == null && !userAcceptDisclaimer ? disclaimer : null
                }
            </div>
       
        </div>
    )
}